// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuelidate from 'vuelidate'
import device from 'vue-device-detector-js'

Vue.use(Vuelidate)
Vue.use(device)

//Styles
require('./assets/css/app.css')
import 'vue-material-design-icons/styles.css'

//Icons
import MenuIcon from 'vue-material-design-icons/menu.vue'
Vue.component('menu-icon', MenuIcon)

import BackIcon from 'vue-material-design-icons/arrow-left.vue'
Vue.component('back-icon', BackIcon)

import MailIcon from 'vue-material-design-icons/email.vue'
Vue.component('email-icon', MailIcon)

import downloadIcon from 'vue-material-design-icons/cloud-download.vue'
Vue.component('download-icon', downloadIcon)

import deleteIcon from 'vue-material-design-icons/delete.vue'
Vue.component('delete-icon', deleteIcon)

//Libs
require('./assets/js/libs/auth.js')
require('./assets/js/libs/storage.js')
require('./assets/js/libs/ui.js')

Vue.config.productionTip = false

new Vue({
    el: '#app',
    data:{
        user: {},
        app: {},
        showMenuButton: false,
        menuToggled: false,
        loading: true,
        overlay: false,
        ui: window.ui
    },
    router,
    components: { App },
    template: '<App/>'
})

//Add filters to Vue
Vue.filter('truncate', window.ui.truncateText);

router.beforeEach((to, from, next) => {
    
    window.ui.hideBackButton();
    next();
})



// WEBPACK FOOTER //
// ./src/main.js